<template>
  <ParkingAreasIndex
    :fst-id="`parking-manager-parking-areas`"
    :pageTitle="
      $t('components.orgUserDetailsManagement.diveIntoTab.parkingArea.headline')
    "
    :qso="{ append: '', prepend: '&' }"
    :hidePlusButton="true"
    :endpoint="getEndpoint"
  />
</template>

<script>
import ParkingAreasIndex from '@/views/geofence/parking-area/index.vue'
import { ParkingAreaConfig } from '@/config/ParkingAreaConfig'
export default {
  name: 'ViewOrganizationUserParkingMangersParkingAreas',

  components: {
    ParkingAreasIndex,
  },
  data() {
    return {}
  },
  computed: {
    getId() {
      return this.$route.params.id
    },

    getEndpoint() {
      return `${ParkingAreaConfig.api.index}?parking_manager=${this.getId}`
    },
  },
}
</script>
